<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------

// -------------------------------
// 🔹 Imports composants
// -------------------------------
import ProductForm from './ProductForm.vue';
import ProductSecondStep from './ProductSecondStep.vue';
import SimPrev from './SimPrev.vue';

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------

// -------------------------------
// 🔹 Imports utilitaires
// -------------------------------

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  indexOfStepProduct,
  arraysStepOne,
  indexOfStepTwoProduct,
  indexOfStepThreeProduct,
  stepTwoActive,
  arraysStepTwo,
  arraysStepThree,
  stepOneActive,
  stepThreeActive,
  NumberOfTotalField,
  stepFourActive,
  indexOfStepFourProduct,
  isReadProduct,
  isUpdatedProduct,
} from '@/refs/product.refs';
import { product_mock } from '@/data/product.mock';
import {
  in_progess_svg,
  in_pending_svg,
  completed_svg,
} from '@/assets/svg/common.svg';
import ProductThreeStep from './ProductThreeStep.vue';
import ProductPrev from './ProductPrev.vue';

// -------------------------------
// 🔹 Imports Types
// -------------------------------

// -------------------------------
// 🔹 Props et emits instanciés
// -------------------------------

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------

// -------------------------------
// 🔹 Récupération des commandes avec Vue Query
// -------------------------------
</script>

<template>
  <section class="flex h-full w-full flex-row gap-8">
    <main
      class="space-y-4"
      :class="!stepFourActive && !stepThreeActive ? 'w-[60%]' : 'w-full'"
    >
      <section class="p-inline-16px rounded-2xl bg-white" v-if="stepOneActive">
        <transition
          enter-active-class="transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
          enter-from-class="opacity-0 translate-y-4 scale-95"
          enter-to-class="opacity-100 translate-y-0 scale-100"
          leave-active-class="transition-all duration-400 ease-[cubic-bezier(0.4,0,0.2,1)]"
          leave-from-class="opacity-100 translate-y-0 scale-100"
          leave-to-class="opacity-0 translate-y-2 scale-95"
        >
          <div class="space-y-6">
            <h1
              class="text-grand-text font-tt-medium-Normal text-20px leading-6"
            >
              Informations du produit
            </h1>

            <ProductForm />
          </div>
        </transition>
      </section>

      <section
        v-else-if="stepTwoActive"
        class="p-inline-16px rounded-2xl bg-white"
      >
        <transition
          enter-active-class="transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
          enter-from-class="opacity-0 translate-y-4 scale-95"
          enter-to-class="opacity-100 translate-y-0 scale-100"
          leave-active-class="transition-all duration-400 ease-[cubic-bezier(0.4,0,0.2,1)]"
          leave-from-class="opacity-100 translate-y-0 scale-100"
          leave-to-class="opacity-0 translate-y-2 scale-95"
        >
          <div class="space-y-6">
            <ProductSecondStep />
          </div>
        </transition>
      </section>

      <section
        v-else-if="stepThreeActive"
        class="p-inline-16px rounded-2xl bg-white"
      >
        <transition
          enter-active-class="transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
          enter-from-class="opacity-0 translate-y-4 scale-95"
          enter-to-class="opacity-100 translate-y-0 scale-100"
          leave-active-class="transition-all duration-400 ease-[cubic-bezier(0.4,0,0.2,1)]"
          leave-from-class="opacity-100 translate-y-0 scale-100"
          leave-to-class="opacity-0 translate-y-2 scale-95"
        >
          <div class="space-y-6">
            <h1
              class="text-grand-text font-tt-medium-Normal text-20px leading-6"
            >
              Ajouter autant d’accompagnements ou d’extras que vous souhaitez
            </h1>

            <ProductThreeStep />
          </div>
        </transition>
      </section>

      <section
        v-else-if="stepFourActive"
        class="p-inline-16px rounded-2xl bg-white"
      >
        <transition
          enter-active-class="transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
          enter-from-class="opacity-0 translate-y-4 scale-95"
          enter-to-class="opacity-100 translate-y-0 scale-100"
          leave-active-class="transition-all duration-400 ease-[cubic-bezier(0.4,0,0.2,1)]"
          leave-from-class="opacity-100 translate-y-0 scale-100"
          leave-to-class="opacity-0 translate-y-2 scale-95"
        >
          <div class="space-y-6">
            <h1
              v-show="!isReadProduct"
              class="text-grand-text font-tt-medium-Normal text-20px leading-6"
            >
              Page de prévisualisation — vérifiez qu’il n’y a pas d’erreurs
            </h1>

            <ProductPrev />
          </div>
        </transition>
      </section>

      <section v-else>
        <h1>Error Value here</h1>
      </section>
    </main>

    <aside
      :class="!stepFourActive && !stepThreeActive ? 'w-full' : 'hidden'"
      v-show="!stepThreeActive && !stepFourActive"
      class="b flex h-[120dvh] flex-col items-center justify-center overflow-hidden"
    >
      <div
        class="h-[120dvh] max-w-full overflow-hidden bg-[url('https://hteteseqxjjlzcvmbfdq.supabase.co/storage/v1/object/public/local-test/62655039-0c78-41dd-9f1a-ea33ab548062/Y_Y7WU2sbmMje31MkqOI7.png')] bg-contain bg-no-repeat"
      >
        <SimPrev />
      </div>
    </aside>
  </section>
</template>
